<template>
  <div class="ui grid" style="width: 100%">
    <div class="row">
      <h1 class="ui huge header">Reports</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <sui-button
        content="Users report"
        icon="excel file outline"
        title="Download users report"
        positive
        v-on:click="downloadUsersReport"
      >
      </sui-button>
      <sui-button
        content="School tests report"
        icon="excel file outline"
        title="Download school tests report"
        positive
        v-on:click="downloadTestsReport"
      >
      </sui-button>
    </div>
  </div>
</template>

<script>
import reportsApi from '@/api/reports';

export default {
  name: 'ReportSelection',
  components: {},
  computed: {},
  data() {
    return {};
  },
  methods: {
    downloadUsersReport() {
      this.downloadReport(reportsApi.getUsersReport);
    },
    downloadTestsReport() {
      this.downloadReport(reportsApi.getTestsReport);
    },
    downloadReport(getReport) {
      this.$store.dispatch('showLoader');
      getReport()
        .then((response) => {
          const blob = new Blob([response.data], { type: response.data.type });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'unknown';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+);/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1].replaceAll('"', '');
            }
          }
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          this.$store.dispatch('hideLoader');
        });
    },
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/reports/ReportSelection.vue